function humanize(string: string): string {
  return string
    .replace(/_/g, ' ') // Remove underscores
    .replace(/\b\w/g, (char: string) => char.toUpperCase()); // Capitalize
}

export default humanize;
